'use strict';
/* jshint ignore:start */
var util = require('site/util');

var multiship = {
	deliveryAddAddress: function (e, address) {
		var obj = {
			'event': 'deliveryAddAddress',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name,
			'delivery_address_saved': '[address saved]',
			'delivery_city': address.city,
			'delivery_country': address.countryCode,
			'delivery_postcode': address.postalCode
		};
		dataLayer.push(obj);
	},

	deliveryRestriction: function (buttonID, country, result) {
		var address = $('.select-address option:selected').text().split(',');
		var postcode = address[address.length - 1];
		var result = JSON.parse(result);
		var numOfProducts = 0;
		if (result.products) {
			numOfProducts = result.products.length;
		}
		if (result.hampers) {
			numOfProducts = result.hampers.length;
		}
		var restriction = 'SORRY! This item cannot be delivered to ' + country;
		if (numOfProducts > 1) {
			restriction = 'SORRY! The following items cannot be delivered to ' + country;
		}
		var obj = {
			'event': 'deliveryRestriction',
			'button_ID': buttonID,
			'delivery_restriction': restriction,
			'delivery_country': country,
			'delivery_postcode': postcode,
			'error_type': 'delivery restricted address',
			'error_id': 'error_checkout_delivery_restrictedaddress_international'
		};
		dataLayer.push(obj);
	},
	trackPageView: function (isOpen) {
		var obj = {
			'event': 'deliveryAddAddressClose'
		};
		if (isOpen) {
			obj.event = 'deliveryAddAddressStart';
		}
		dataLayer.push(obj);
	},
	trackEvent: function (event, stepValue, stepKey) {
		var obj = {
			'event': event
		};
		// assign step value, with no value fallback
		var key = stepKey || 'event_step';
		obj[key] = stepValue || (key + ' not available');
		dataLayer.push(obj);
	}
}

module.exports = multiship
/* jshint ignore:end */
